import * as api from '../api/customers.js';
import { casesEntity } from '../cases/index.js';
import { customersEntity } from '../customers/index.js';
import q from '../query.js';
import keys from '@debbie/common/dist/cache/keys.js';
const customerRelatedCasesKey = (customerId) => `customer-related-cases-${customerId}`;
export const useCustomerRelatedCases = (customerId, casualConsistency) => q.query(customerRelatedCasesKey(customerId), () => api.getRelatedCases(customerId), [
    ...keys.read.item(customersEntity, customerId),
    ...keys.read.collection(casesEntity),
], { enabled: customerId != null });
//# sourceMappingURL=index.js.map